/** @format */
import {CheckCircleOutline, ViewListOutlined} from '@mui/icons-material';

import {useNavigate} from 'react-router-dom';

import {Trans} from 'react-i18next';

import {
  ContentBox,
  HeadingBox,
  HeadingText,
  MessageBox,
  MessageText,
  OkButton,
  Root,
} from './styles';

const SubmitResult = () => {
  const navigate = useNavigate();

  const handleGoToProjects = () => {
    navigate('/grouping');
  };

  return (
    <Root>
      <ContentBox>
        <HeadingBox>
          <CheckCircleOutline fontSize='large' />
          <HeadingText>
            <Trans>Заявка принята</Trans>
          </HeadingText>
        </HeadingBox>

        <MessageBox>
          <MessageText>
            <Trans>Спасибо за доверие!</Trans>
          </MessageText>
          <MessageText>
            <Trans>Мы свяжемся с вами в ближайшее время</Trans>
          </MessageText>
        </MessageBox>

        <OkButton onClick={handleGoToProjects}>
          <ViewListOutlined />
          <Trans>Перейти к проектам</Trans>
        </OkButton>
      </ContentBox>
    </Root>
  );
};

export {SubmitResult};
